import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { Series } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputText, ValidatedText } from '@/components';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class SeriesGuiDef extends GuiDef<Series> {
    constructor() {
        super('Series');

        const Name = new FieldDef<Series>();
        Name.Name = 'Name';
        Name.FieldName = 'Name';
        Name.DefinedFor = 'Both';
        Name.TranslationKey = 'series.name';
        Name.Editable = true;
        Name.Filterable = true;
        Name.Sortable = true;
        Name.CssClasses = '';
        Name.value = (series) => series.Name;
        Name.setValue = (series, value) => (series.Name = value);
        Name.DetailEditor = markRaw(InputText);
        Name.DetailEditorProps = {};
        Name.CellEditor = markRaw(InputText);
        Name.CellEditorProps = {};
        Name.CellRenderer = markRaw(ValidatedText);
        Name.CellRendererProps = {};
        Name.Validator = null;
        Name.SortDirection = undefined;
        Name.cellClassRules = undefined;
        Name.MinWidth = undefined;
        Name.MaxWidth = undefined;
        Name.Tooltip = null;
        this.Fields.push(Name);
    }

    public async LoadDependencies() {}
}
